import { defineMessages } from 'react-intl';
var messages = defineMessages({
  nameMenuItemLabel: {
    id: "General.nameLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Name"
    }]
  },
  continueLearningTitle: {
    id: "Courses.continueLearningTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Continue learning"
    }]
  },
  startLearningTitle: {
    id: "Courses.startLearningTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Start learning"
    }]
  },
  addNewCourseTitle: {
    id: "Courses.addNewCourseTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Add new course"
    }]
  },
  noCoursesHereLabel: {
    id: "Courses.noCoursesHereLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Nothing here yet"
    }]
  },
  noLessonsHereLabel: {
    id: "Courses.noLessonsHereLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Nothing here yet"
    }]
  },
  noResultsHere: {
    id: "Courses.noResultsHere",
    defaultMessage: [{
      "type": 0,
      "value": "Nothing was found with specified filters"
    }]
  },
  courseTitle: {
    id: "Courses.courseTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Course"
    }]
  },
  courseLessonsCountTitle: {
    id: "Courses.courseLessonsCountTitle",
    defaultMessage: [{
      "type": 1,
      "value": "lessons"
    }, {
      "type": 0,
      "value": " lessons ("
    }, {
      "type": 1,
      "value": "hours"
    }, {
      "type": 0,
      "value": " h "
    }, {
      "type": 1,
      "value": "minutes"
    }, {
      "type": 0,
      "value": " min)"
    }]
  },
  taskToDoText: {
    id: "Courses.taskToDoText",
    defaultMessage: [{
      "type": 0,
      "value": "You have "
    }, {
      "type": 1,
      "value": "amount"
    }, {
      "type": 0,
      "value": " task to do"
    }]
  },
  examScoreText: {
    id: "Courses.examScoreText",
    defaultMessage: [{
      "type": 0,
      "value": "You last scored "
    }, {
      "type": 1,
      "value": "score"
    }, {
      "type": 0,
      "value": " at "
    }, {
      "type": 1,
      "value": "examName"
    }, {
      "type": 0,
      "value": " exam"
    }]
  },
  quizScoreText: {
    id: "Courses.quizScoreText",
    defaultMessage: [{
      "type": 0,
      "value": "You last scored "
    }, {
      "type": 1,
      "value": "score"
    }, {
      "type": 0,
      "value": " at "
    }, {
      "type": 1,
      "value": "quizName"
    }, {
      "type": 0,
      "value": " quiz"
    }]
  },
  discussionsTitle: {
    id: "Courses.discussionsTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Discussions"
    }]
  },
  classroomTitle: {
    id: "Courses.classroomTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Classroom"
    }]
  },
  followedTitle: {
    id: "Courses.followedTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Followed"
    }]
  },
  hideDashboardBtnLabel: {
    id: "Courses.hideDashboardBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Hide dashboard"
    }]
  },
  showDashboardBtnLabel: {
    id: "Courses.showDashboardBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Show dashboard"
    }]
  },
  allCoursesBtnLabel: {
    id: "Courses.allCoursesBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "All Courses"
    }]
  },
  skholeCoursesBtnLabel: {
    id: "Courses.skholeCoursesBtnLabel",
    defaultMessage: [{
      "type": 1,
      "value": "serviceNamePossessive"
    }, {
      "type": 0,
      "value": " Courses"
    }]
  },
  recentlyAccessedMenuItemLabel: {
    id: "Courses.recentlyAccessedMenuItemLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Recently accessed"
    }]
  },
  progressMenuItemLabel: {
    id: "Courses.progressMenuItemLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Progress"
    }]
  },
  popularityMenuItemLabel: {
    id: "Courses.popularityMenuItemLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Popularity"
    }]
  },
  orderTitle: {
    id: "Courses.orderTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Order"
    }]
  },
  ascendingMenuItemLabel: {
    id: "Courses.ascendingMenuItemLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Ascending"
    }]
  },
  descendingMenuItemLabel: {
    id: "Courses.descendingMenuItemLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Descending"
    }]
  },
  loadingBtnLabel: {
    id: "Courses.loadingBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Loading..."
    }]
  },
  loadMoreBtnLabel: {
    id: "Courses.loadMoreBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Load more"
    }]
  },
  publishDateItemLabel: {
    id: "Courses.publishDateItemLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Publish date"
    }]
  },
  haveMessagesText: {
    id: "Courses.haveMessagesText",
    defaultMessage: [{
      "type": 0,
      "value": "You have "
    }, {
      "type": 1,
      "value": "amount"
    }, {
      "type": 0,
      "value": " unread notification(s)"
    }]
  },
  nothingToShowTitle: {
    id: "Courses.nothingToShowTitle",
    defaultMessage: [{
      "type": 0,
      "value": "Nothing to show here, yet."
    }]
  },
  courses: {
    id: "Courses.courses",
    defaultMessage: [{
      "type": 0,
      "value": "Courses"
    }]
  },
  searchCoursesResults: {
    id: "Courses.searchCoursesResults",
    defaultMessage: [{
      "type": 1,
      "value": "total"
    }, {
      "type": 0,
      "value": " results"
    }]
  },
  lessons: {
    id: "Courses.lessons",
    defaultMessage: [{
      "type": 0,
      "value": "Lessons"
    }]
  },
  searchLessonsResults: {
    id: "Courses.searchLessonsResults",
    defaultMessage: [{
      "type": 1,
      "value": "total"
    }, {
      "type": 0,
      "value": " results"
    }]
  },
  updatingOfflineContent: {
    id: "Courses.updatingOfflineContent",
    defaultMessage: [{
      "type": 0,
      "value": "Syncing offline mode state..."
    }]
  },
  updatedOfflineContent: {
    id: "Courses.updatedOfflineContent",
    defaultMessage: [{
      "type": 0,
      "value": "Offline mode state sync finished."
    }]
  },
  myCoursesBtn: {
    id: "Courses.myCoursesBtn",
    defaultMessage: [{
      "type": 0,
      "value": "My courses"
    }]
  },
  favouriteCoursesBtn: {
    id: "Courses.favouriteCoursesBtn",
    defaultMessage: [{
      "type": 0,
      "value": "Favourite courses"
    }]
  },
  clearFilterLong: {
    id: "Courses.clearFilterLong",
    defaultMessage: [{
      "type": 0,
      "value": "Clear filters"
    }]
  },
  clearFilterShot: {
    id: "Courses.clearFilterShot",
    defaultMessage: [{
      "type": 0,
      "value": "Clear"
    }]
  },
  applyCategoryFilter: {
    id: "Courses.applyCategoryFilter",
    defaultMessage: [{
      "type": 0,
      "value": "Apply"
    }]
  },
  filtersAndOrderBtnLabel: {
    id: "Courses.filtersAndOrderBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Filter and Order"
    }]
  },
  amountAppliedLabel: {
    id: "Courses.amountAppliedLabel",
    defaultMessage: [{
      "type": 1,
      "value": "amount"
    }, {
      "type": 0,
      "value": " applied"
    }]
  },
  serviceNamePossessive: {
    id: "General.serviceNamePossessive",
    defaultMessage: [{
      "type": 0,
      "value": "Skhole"
    }]
  },
  emptyDashboard: {
    id: "Courses.emptyDashboard",
    defaultMessage: [{
      "type": 0,
      "value": "Nothing to show on your dashboard yet."
    }]
  },
  browseByCategoryBtnLabel: {
    id: "Header.browseByCategoryBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Click to select"
    }]
  },
  browseByContentCategoryBtnLabel: {
    id: "Header.browseByContentCategoryBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Click to select"
    }]
  },
  browseByCategorySelectedBtnLabel: {
    id: "Header.browseByCategorySelectedBtnLabel",
    defaultMessage: [{
      "type": 1,
      "value": "amountSelected"
    }, {
      "type": 0,
      "value": " selected"
    }]
  },
  selectAllLabel: {
    id: "Header.selectAllLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Select All"
    }]
  },
  showGrid: {
    id: "Courses.showGrid",
    defaultMessage: [{
      "type": 0,
      "value": "Show grid"
    }]
  },
  showList: {
    id: "Courses.showList",
    defaultMessage: [{
      "type": 0,
      "value": "Show list"
    }]
  },
  customersCourses: {
    id: "Courses.customersCourses",
    defaultMessage: [{
      "type": 0,
      "value": "Other courses"
    }]
  },
  browseByCategoryBtnTooltip: {
    id: "Courses.browseByCategoryBtnTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Filter courses based on categories"
    }]
  },
  browseByTagBtnTooltip: {
    id: "Courses.browseByTagBtnTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Filter courses based on classification"
    }]
  },
  allCoursesBtnTooltip: {
    id: "Courses.allCoursesBtnTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Filter courses - Show all courses"
    }]
  },
  skholeCoursesBtnToolTip: {
    id: "Courses.skholeCoursesBtnToolTip",
    defaultMessage: [{
      "type": 0,
      "value": "Filter courses - Show courses created by "
    }, {
      "type": 1,
      "value": "serviceNameToUse"
    }]
  },
  customersCoursesToolTip: {
    id: "Courses.customersCoursesToolTip",
    defaultMessage: [{
      "type": 0,
      "value": "Filter courses - Show courses created by others than "
    }, {
      "type": 1,
      "value": "serviceNameToUse"
    }]
  },
  favouriteCoursesBtnTooltip: {
    id: "Courses.favouriteCoursesBtnTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Filter courses - Show courses you have marked as favourite"
    }]
  },
  myCoursesBtnTooltip: {
    id: "Courses.myCoursesBtnTooltip",
    defaultMessage: [{
      "type": 0,
      "value": "Filter courses - Show courses you have marked as favourite or that have been assigned to you"
    }]
  },
  livestreamType: {
    id: "Courses.livestreamType",
    defaultMessage: [{
      "type": 0,
      "value": "Live broadcast"
    }]
  },
  podcastType: {
    id: "Courses.podcastType",
    defaultMessage: [{
      "type": 0,
      "value": "Podcast"
    }]
  },
  normalType: {
    id: "Courses.normalType",
    defaultMessage: [{
      "type": 0,
      "value": "Course"
    }]
  },
  allLabel: {
    id: "General.allLabel",
    defaultMessage: [{
      "type": 0,
      "value": "All"
    }]
  },
  courseTypeFilterLabel: {
    id: "Courses.courseTypeFilterLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Content type"
    }]
  },
  languageFilterLabel: {
    id: "Courses.languageFilterLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Language"
    }]
  },
  classificationFilterLabel: {
    id: "Courses.classificationFilterLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Content filter"
    }]
  },
  categoriesBlockLabel: {
    id: "Courses.categoriesBlockLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Category"
    }]
  },
  tagsBlockLabel: {
    id: "Courses.tagsBlockLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Classification"
    }]
  }
});
export default messages;